<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-area
                :title="checkHandleAlter ? 'Alterar cota' : 'Cadastrar cota'"
                type="fieldset"
            >
                <rkm-row class="flex-nowrap">

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="data.form.tipo"
                            label="Tipo"
                            show-default-option
                            text-field="descricao"
                            v-model="unidade.cotaTipoId"
                            value-field="id"
                            :validations="validations.tipo"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1" v-show="unidade.cotaTipoId == enums.tipoCota.QUANTIDADE">
                        <rkm-form-input
                            label="Cota"
                            v-model="unidade.cotaQuantidade"
                            :validations="unidade.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                            number
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1" v-show="unidade.cotaTipoId != enums.tipoCota.QUANTIDADE">
                        <rkm-form-input
                            label="Cota"
                            ref="cotaValor"
                            v-model="unidade.cotaValor"
                            :validations="unidade.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                            v-money="money"
                            prepend="R$"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="unidade.periodo"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                            :disabled="unidade.periodo.start && unidade.periodo.end ? true : false"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            label="Observação"
                            v-model="unidade.observacao"
                            name="observacao"
                            rows="2"
                            max-rows="2"
                            :validations="validations.observacao"
                            class="mb-0"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col>
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click.stop="handleCota()"
                            class="mt-0 float-right"
                        >
                            {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                        </rkm-button>

                        <rkm-button
                            v-if="checkHandleAlter"
                            :label="false"
                            color="secondary"
                            @click.stop="hideAlter()"
                            class="mt-0 mr-2 float-right"
                        >
                            Voltar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <List
            v-if="!checkHandleAlter"
            :cotaLaboratorio="cotaLaboratorio"
            :checkLaboratorio="checkLaboratorio"
            :infraestruturaId="infraestruturaId"
            :unidadeId="unidadeId"
            :data="data"
            :cotaAno="cotaAno"
            @handleAlter="handleAlter"
            @copyCota="copyCota"
            @save="save"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import List from './List'

// Mixins.
import { repository, object, data, mask, formats } from '@/mixins'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

//Directives
import { VMoney } from 'v-money'

// Moment.
import moment from 'moment'

export default {
    components: { List },
    directives: { money: VMoney },
    mixins: [ repository, object, data, mask, formats ],
    computed: {
        validations() {

            return {
                observacao: { max: 500 },
                cotaValor: { max: 13, min_value: 0.01 },
                cotaQuantidade: { min_value: 1, required: true },
                tipo: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        isLoading() {
            return this.$store.state.loading > 0
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.unidade.unidadeSolicitanteId) {

                return this.laboratorioSolicitante.find(u =>
                    u.unidadeSolicitanteId === this.unidade.unidadeSolicitanteId).local
            }

            return []
        },
        maxDate() {

            if (this.unidade.periodo.start) {

               return moment(this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD'))
                .endOf("month").format('DD-MM-YYYY')
            }

            return null
        },
        minDate() {

            if (this.unidade.periodo.end) {

               return moment(this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'))
                .startOf("month").format('DD-MM-YYYY')
            }

            return null
        },
    },
    watch: {
    isLoading(novoValor) {
        if (!novoValor && this.aguardandoConfirmacao) {
        this.mostraConfirmacao();
        this.aguardandoConfirmacao = false;
        }
    }
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    const unidade = this.clone(this.unidade)

                    unidade.periodo.start = this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')
                    unidade.periodo.end = this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')
                    unidade.cotaValor = unidade.cotaValor.replace('R$ ', '')

                    unidade.unidadeTipoId = this.enums.tipoUnidade.LABORATORIO
                    unidade.unidadeId = this.unidadeId
                    unidade.infraestruturaId = this.infraestruturaId

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {
                        unidade.cotaTipoNome = 'Valor'
                        unidade.cota = unidade.cotaValor
                        unidade.saldo = unidade.cotaValor
                        unidade.cotaQuantidade = ''
                    } else {
                        unidade.cotaTipoNome = 'Quantidade'
                        unidade.cota = unidade.cotaQuantidade
                        unidade.saldo = unidade.cotaQuantidade
                        unidade.cotaValor = "0,00"
                    }

                    unidade.utilizada = '0'

                  if (this.hasIndex) {

                       const objIndex = this.cotaLaboratorio.findIndex((obj => obj.id == this.unidade.id));

                        this.$set(this.cotaLaboratorio, objIndex, this.clone(unidade))

                        this.checkHandleAlter = false
                        this.$emit('handleHideUnidadeSolicitante', false)
                        this.index = null
                    } else {

                        unidade.id = this.uniqueId(`unidade-${this.unidadeId}${this.infraestruturaId}${this.unidade.cotaTipoId}${
                            this.getFormatedDate(this.unidade.periodo.start, 'DDMMYYYY')}`)

                        this.cotaLaboratorio.push(unidade)
                    }

                    this.$emit('save', this.getFormatedDate(this.unidade.periodo.end, 'YYYY'))
                    this.handleAlert()
                    this.resetForm()
                })
        },
        async validate() {

            if (!this.unidadeDisabled && this.data.model.cotasLaboratorio.find((unidade, i) => i !== this.newIndex &&
                unidade.unidadeId == this.unidadeId && unidade.infraestruturaId == this.infraestruturaId)) {

                this.showValidationNotification('Unidade e local de atendimento já parametrizados.')

                return false
            }

            if (this.unidadeId === null) {

                this.showValidationNotification('Obrigatório selecionar a unidade.')

                return false
            }

            if (this.infraestruturaId === null) {

                this.showValidationNotification('Obrigatório selecionar o local de atendimento.')

                return false
            }

            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

            let utilizadas = this.utilizadas
            let cotaValor = this.unidade.cota

            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                utilizadas = this.utilizadas.replace('.','').replace(',','.')
                cotaValor = this.unidade.cota.replace('.','').replace(',','.')

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos agendamentos para o laboratório
                        <strong>${unidade.nomeFantasia}</strong> e o local de
                        atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>R$ ${this.utilizadas}</strong>.
                        `)

                    return false
                }
            } else {

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos agendamentos para o laboratório
                        <strong>${unidade.nomeFantasia}</strong> e o local de
                        atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')} até
                        ${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.utilizadas}</strong>.
                        `)

                    return false
                }
            }

            const hasSetor = this.cotaLaboratorio
                .find((cc) =>
                    cc.id !== this.unidade.id
                        && cc.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                                this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD')
                            )
                            .isBetween(
                                cc.periodo.start.split("/").reverse().join("-"),
                                cc.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                    || cc.id !== this.unidade.id
                        && cc.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                                this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD')
                            )
                            .isBetween(
                                cc.periodo.start.split("/").reverse().join("-"),
                                cc.periodo.end.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                    || cc.id !== this.unidade.id
                        && cc.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                                this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD')
                            )
                            .isBefore(
                                cc.periodo.start.split("/").reverse().join("-"),
                            )
                        && moment(this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'))
                            .isAfter(
                                cc.periodo.end.split("/").reverse().join("-"),
                            )
                )

            if (hasSetor) {

              this.showValidationNotification(`Já existe um registro para este laboratório com o tipo e entre o período
                selecionado.`)

               return false
            }

            if (this.hasIndex) {

                if (this.cotaLaboratorio.find(cc => cc.id == this.unidade.id).exames.length > 0) {

                    this.cotaLaboratorio.find(cc => cc.id == this.unidade.id).exames
                        .map(saldo => {

                        if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.cotaAtribuida = this.cotaAtribuida + this.formatSumMoney(saldo.cota);
                        } else {

                            this.cotaAtribuida = this.cotaAtribuida + Number(saldo.cota);
                        }
                    })

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        let cotaValor = this.unidade.cotaValor.replace('.','').replace(',','.')

                        if (cotaValor < this.cotaAtribuida) {

                            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                            this.showValidationNotification(`A cota é menor que a cota atribuída
                                para os exames em (Parametrização > Cotas
                                > Laboratório > Exames), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                local de atendimento <strong>${infraestrutura}</strong> no período de
                                <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                A cota deve ser maior ou igual a <strong>R$ ${this.formatMoney(this.cotaAtribuida,2)}</strong>.
                                `)

                            this.cotaAtribuida = null

                            return false
                        }

                    } else {

                        if (this.unidade.cotaQuantidade < this.cotaAtribuida) {

                            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                            this.showValidationNotification(`A cota é menor que a cota atribuída
                                para os exames em (Parametrização > Cotas
                                > Laboratório > Exames), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                local de atendimento <strong>${infraestrutura}</strong> no período de
                                <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                A cota deve ser maior ou igual a <strong>${this.formatMoney(this.cotaAtribuida,0)}</strong>.
                                `)

                            this.cotaAtribuida = null

                            return false
                        }
                    }
                }

                if (this.cotaLaboratorio.find(cc => cc.id == this.unidade.id).unidadeSolicitante.length > 0) {

                    this.cotaAtribuida = 0

                    this.cotaLaboratorio.find(cc => cc.id == this.unidade.id).unidadeSolicitante.map(saldo => {

                        if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.cotaAtribuida = this.cotaAtribuida + this.formatSumMoney(saldo.cota);
                        } else {

                            this.cotaAtribuida = this.cotaAtribuida + Number(saldo.cota);
                        }
                    })

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        let cotaValor = this.unidade.cotaValor.replace('.','').replace(',','.')

                        if (cotaValor < this.cotaAtribuida) {

                            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                            this.showValidationNotification(`A cota é menor que a cota atribuída
                                para as unidades solicitantes em (Parametrização > Cotas
                                > Laboratório > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                local de atendimento <strong>${infraestrutura}</strong> no período de
                                <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                A cota deve ser maior ou igual a <strong> R$ ${this.formatMoney(this.cotaAtribuida,2)}</strong>.
                                `)

                            this.cotaAtribuida = null

                            return false
                        }

                    } else {

                        if (this.unidade.cotaQuantidade < this.cotaAtribuida) {

                            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeId)
                            const infraestrutura = unidade.infraestruturas.find(s => s.id === this.infraestruturaId).nome

                            this.showValidationNotification(`A cota é menor que a cota atribuída
                                para as unidades solicitantes em (Parametrização > Cotas
                                > Laboratório > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                                local de atendimento <strong>${infraestrutura}</strong> no período de
                                <strong>${this.getFormatedDate(this.unidade.periodo.start, 'DD/MM/YYYY')}</strong> até
                                <strong>${this.getFormatedDate(this.unidade.periodo.end, 'DD/MM/YYYY')}</strong>.
                                A cota deve ser maior ou igual a <strong>${this.formatMoney(this.cotaAtribuida,0)}</strong>.
                                `)

                            this.cotaAtribuida = null

                            return false
                        }
                    }
                }
            }

            return true
        },
        handleCota() {

            this.setLoading()

            this.repositories.saldo.saldoUnidadeSolicitante({
                unidade_id: this.unidadeId,
                infraestrutura_id: this.infraestruturaId,
                inicio: this.getFormatedDate(this.unidade.periodo.start, 'YYYY-MM-DD'),
                fim: this.getFormatedDate(this.unidade.periodo.end, 'YYYY-MM-DD'),
                cota_tipo_id: this.unidade.cotaTipoId,
            })
                .then(response => {

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.unidade.cota = this.unidade.cotaValor
                    } else {

                        this.unidade.cota = this.unidade.cotaQuantidade
                    }

                    this.getCotaUtilizada(response.data)

                    this.$refs.Form.validate(this.add)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(items) {

            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
            } else {

                this.utilizadas = items.quantidadeAgendada
            }
        },
        resetForm() {

            this.index = null
            this.aguardandoConfirmacao = false
            this.unidade.id = null
            this.unidade.cotaTipoId = null
            this.unidade.unidadeTipoId = ''
            this.unidade.observacao = ''
            this.unidade.cotaQuantidade = ''
            this.unidade.periodo.start = null
            this.unidade.periodo.end = null
            this.unidade.cotaValor = null
            this.unidade.saldo = null
            this.cotaAtribuida = null
            this.unidade.utilizada = ''
            this.unidade.unidadeSolicitante = []
            this.unidade.exames = []
            this.checkUnidadeSolicitante = true
            this.unidade.valorUtilizado = 0
            this.unidade.quantidadeUtilizada = 0
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = 0;
            this.examesSemSaldo = [],
            this.unidadeSemSaldo = [],

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(index) {

            const destroy = async () => {

                this.cotaLaboratorio.splice(index, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota?`,
                destroy)
        },
        handleAlter(index, item) {

            this.resetForm()

            this.index = index
            this.unidade.id = item.id
            this.unidade.cotaQuantidade = item.cotaQuantidade
            this.unidade.quantidadeUtilizada = item.quantidadeUtilizada
            this.unidade.cotaValor = item.cotaValor
            this.unidade.valorUtilizado = item.valorUtilizado
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor
            this.unidade.observacao = item.observacao

            this.unidade.periodo.start = moment(
                item.periodo.start,
                'DD/MM/YYYY'
            ).toDate()

            this.unidade.periodo.end = moment(
                item.periodo.end,
                'DD/MM/YYYY'
            ).toDate()

            this.unidade.exames =  item.exames
            this.unidade.unidadeSolicitante = item.unidadeSolicitante
            this.unidade.cotaTipoId = item.cotaTipoId
            this.checkHandleAlter = true

            this.$emit('handleHideUnidadeSolicitante', true)
        },
        copyCota(item) {

            this.resetForm()

            this.unidade.cota = item.cota
            this.unidade.cotaTipoId = item.cotaTipoId
            this.unidade.cotaQuantidade = item.cotaQuantidade
            this.unidade.quantidadeUtilizada = '0'
            this.unidade.cotaValor = item.cotaValor
            this.unidade.valorUtilizado = '0'
            this.$refs.cotaValor.$el.getElementsByTagName('input')[0].value = item.cotaValor
            this.unidade.observacao = item.observacao
            this.unidade.unidadeAlterada = true
            this.unidade.exameAlterado = true

            this.unidade.periodo.start = moment(
                item.periodo.start,
                'DD/MM/YYYY'
            ).add(1, 'month').toDate()

            this.unidade.periodo.end = moment(
                item.periodo.end,
                'DD/MM/YYYY'
            ).add(1, 'month').toDate()

            if (item.exames.length > 0) {

                let cota = this.data.model.cotasExamePeriodo.find(unidade =>
                    unidade.infraestruturaId == item.infraestruturaId
                    && unidade.cotaTipoId == item.cotaTipoId
                    && moment(
                        moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    ).isBetween(
                        unidade.periodo.start.split("/").reverse().join("-"),
                        unidade.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    ).isBetween(
                        unidade.periodo.start.split("/").reverse().join("-"),
                        unidade.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                )

                if (cota) {

                    this.setLoading()

                    this.repositories.saldo.getCotaExame({
                        infraestrutura_id: this.infraestruturaId,
                        cota_tipo_id: item.cotaTipoId,
                        inicio: this.getFormatedDate(cota.periodo.start, 'YYYY-MM-DD', 'DD/MM/YYYY'),
                        fim: this.getFormatedDate(cota.periodo.end, 'YYYY-MM-DD', 'DD/MM/YYYY'),
                    })
                        .then(response => {

                            const exames = response.data

                            this.unidade.exames = item.exames
                                .filter(exame => { return this.handleExame(this.unidade, exame, exames) })
                                .map(exame => {

                                    const novoExame = {...exame}
                                    novoExame.cotaExamePeriodoId = null
                                    novoExame.cotaQuantidadeTransferido = 0
                                    novoExame.cotaValorTransferido = 0
                                    novoExame.quantidadeUtilizada = '0'
                                    novoExame.valorUtilizado = '0'
                                    novoExame.transferido = 0
                                    novoExame.unidadeSolicitante = novoExame.unidadeSolicitante
                                        .filter(unidadeSolicitante => { return this.handleCotaUnidadeSolicitante(unidadeSolicitante) })
                                        .map(unidadeSolicitante => {

                                            const exameUnidadeSolicitante = {...unidadeSolicitante}
                                            exameUnidadeSolicitante.cotaId = null
                                            exameUnidadeSolicitante.id = null
                                            exameUnidadeSolicitante.quantidadeUtilizada = '0'
                                            exameUnidadeSolicitante.valorUtilizado = '0'
                                            exameUnidadeSolicitante.transferencia = 0
                                            exameUnidadeSolicitante.transferenciaRecebida = 0

                                            return exameUnidadeSolicitante
                                        })

                                    return novoExame
                                })
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            } else {

                this.getCotaLaboratorioExame(item)
            }

            if (item.unidadeSolicitante.length) {

                this.unidade.unidadeSolicitante = item.unidadeSolicitante
                    .filter(unidadeSolicitante => { return this.handleCotaUnidadeSolicitante(unidadeSolicitante) })
                    .map(unidadeSolicitante => {

                        const novoUnidadeSolicitante = {...unidadeSolicitante}

                        novoUnidadeSolicitante.id = null
                        novoUnidadeSolicitante.quantidadeUtilizada = '0'
                        novoUnidadeSolicitante.valorUtilizado = '0'
                        novoUnidadeSolicitante.transferencia = 0
                        novoUnidadeSolicitante.transferenciaRecebida = 0

                        return novoUnidadeSolicitante
                    })
            } else {

                this.getCotaLaboratorioUnidade(item)
            }

            if (this.isLoading) {
                this.aguardandoConfirmacao = true
                return;
            }

            this.mostraConfirmacao()
        },
        mostraConfirmacao() {
            this.showConfirmation(
                'Deseja replicar a cota para o próximo mês?',
                async () => this.handleCota(),
                async () => this.resetForm(),
            )
        },
        getCotaLaboratorioUnidade(item) {

            this.setLoading()

            this.repositories.saldo.getCotaLaboratorioUnidade({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.cotaTipoId,
                cota_id: item.id,
                inicio: moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                fim: moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            })
                .then(response => {

                    this.unidade.unidadeSolicitante = response.data
                        .filter(unidadeSolicitante => { return this.handleCotaUnidadeSolicitante(unidadeSolicitante) })
                        .map(unidadeSolicitante => {

                            const novoUnidadeSolicitante = {...unidadeSolicitante}

                            novoUnidadeSolicitante.id = null
                            novoUnidadeSolicitante.quantidadeUtilizada = '0'
                            novoUnidadeSolicitante.valorUtilizado = '0'
                            novoUnidadeSolicitante.transferencia = 0
                            novoUnidadeSolicitante.transferenciaRecebida = 0

                            return novoUnidadeSolicitante
                        })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaLaboratorioExame(item) {

            this.setLoading()

            this.repositories.saldo.getCotaLaboratorioExame({
                infraestrutura_id: item.infraestruturaId,
                cota_tipo_id: item.cotaTipoId,
                cota_id: item.id,
                inicio: moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                fim: moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                unidades_solicitantes: true,
            })
            .then(response => {

                let cota = this.data.model.cotasExamePeriodo.find(unidade =>
                    unidade.infraestruturaId == item.infraestruturaId
                    && unidade.cotaTipoId == item.cotaTipoId
                    && moment(
                        moment(item.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    ).isBetween(
                        unidade.periodo.start.split("/").reverse().join("-"),
                        unidade.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        moment(item.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    ).isBetween(
                        unidade.periodo.start.split("/").reverse().join("-"),
                        unidade.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                )

                if (cota) {

                    this.setLoading()

                    this.repositories.saldo.getCotaExame({
                        infraestrutura_id: item.infraestruturaId,
                        cota_tipo_id: item.cotaTipoId,
                        inicio: this.getFormatedDate(cota.periodo.start, 'YYYY-MM-DD', 'DD/MM/YYYY'),
                        fim: this.getFormatedDate(cota.periodo.end, 'YYYY-MM-DD', 'DD/MM/YYYY'),
                    })
                    .then(data => {

                        const exames = data.data

                        this.unidade.exames = response.data
                            .filter(exame => { return this.handleExame(this.unidade, exame, exames)})
                            .map(exame => {

                                const novoExame = {...exame}
                                novoExame.cotaExamePeriodoId = null
                                novoExame.cotaQuantidadeTransferido = 0
                                novoExame.cotaValorTransferido = 0
                                novoExame.quantidadeUtilizada = '0'
                                novoExame.valorUtilizado = '0'
                                novoExame.transferido = 0
                                novoExame.unidadeSolicitanteAlterada = true
                                novoExame.unidadeSolicitante = novoExame.unidadeSolicitante
                                    .filter(unidadeSolicitante => { return this.handleCotaUnidadeSolicitante(unidadeSolicitante) })
                                    .map(unidadeSolicitante => {

                                        const exameUnidadeSolicitante = {...unidadeSolicitante}
                                        exameUnidadeSolicitante.cotaId = null
                                        exameUnidadeSolicitante.id = null
                                        exameUnidadeSolicitante.quantidadeUtilizada = '0'
                                        exameUnidadeSolicitante.valorUtilizado = '0'
                                        exameUnidadeSolicitante.transferencia = 0
                                        exameUnidadeSolicitante.transferenciaRecebida = 0

                                        return exameUnidadeSolicitante
                                    })

                                return novoExame
                            })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        handleAlert() {

            let msg = ''

            if (this.examesSemSaldo.length > 0) {
                let exames = this.examesSemSaldo.map(exame => { return exame.nome }).join(',')
                msg = `As cotas do(s) exame(s) <strong>${exames}</strong> não puderam ser replicadas devido ao saldo insuficiente. <br>`
            }

            if (this.unidadeSemSaldo.length > 0) {
                let unidades = this.unidadeSemSaldo.map(unidade => { return unidade.unidadeSolicitante + ' - ' + unidade.infraestruturaNome }).join(',')
                msg = msg + `As cotas da(s) unidade(s) <strong>${unidades}</strong> não puderam ser replicadas devido ao saldo insuficiente.`
            }

            if (msg !== '') {
                this.showAlert(msg, 'Atenção')
            }
        },
        handleCotaUnidadeSolicitante(item) {

            let liberado = true
            let unidadeSolicitante = this.data.model.cotasUnidadeSolicitante
                .find(unidade => unidade.infraestruturaId == item.infraestruturaSolicitanteId)

            if (unidadeSolicitante) {

                let cotaUnidadeSolicitante = unidadeSolicitante.cotaUnidadeSolicitante
                    .find(unidade => unidade.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                            moment(this.unidade.periodo.start).format('YYYY-MM-DD')
                        ).isBetween(
                            unidade.periodo.start.split("/").reverse().join("-"),
                            unidade.periodo.end.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )
                        && moment(
                            moment(this.unidade.periodo.end).format('YYYY-MM-DD')
                        ).isBetween(
                            unidade.periodo.start.split("/").reverse().join("-"),
                            unidade.periodo.end.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )
                    )

                if (cotaUnidadeSolicitante) {

                    let saldo = this.getSaldo(this.handleTranferencia(item, cotaUnidadeSolicitante))
                    let cotaAtribuida = this.getCotaAtribuida(item, cotaUnidadeSolicitante)

                    if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if (this.formatSumMoney(item.cota) > (this.formatSumMoney(saldo) - this.formatSumMoney(cotaAtribuida))) {
                            this.unidadeSemSaldo.push(item)
                            liberado = false
                        }
                    } else {

                        if (Number(item.cota) > (Number(saldo) - Number(cotaAtribuida))) {
                            this.unidadeSemSaldo.push(item)
                            liberado = false
                        }
                    }
                }
            }

            return liberado
        },
        getCotaAtribuida(unidade, cotaUnidadeSolicitante) {

            let cotasAtribuidas = 0
            let cotaAtribuida = 0

            const cota = this.data.model.cotasLaboratorio

            if (cota) {

                cota.map(item => item.cotaLaboratorio
                    .filter(field  => field.cotaTipoId == this.unidade.cotaTipoId
                        && moment(
                            field.periodo.start.split("/").reverse().join("-")
                        )
                        .isBetween(
                            cotaUnidadeSolicitante.periodo.start.split("/").reverse().join("-"),
                            cotaUnidadeSolicitante.periodo.end.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )
                        && moment(
                            field.periodo.end.split("/").reverse().join("-")
                        )
                        .isBetween(
                            cotaUnidadeSolicitante.periodo.start.split("/").reverse().join("-"),
                            cotaUnidadeSolicitante.periodo.end.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )
                    )
                    .map(unidadeSolicitante => {

                        cotaAtribuida = unidadeSolicitante.unidadeSolicitante
                            .filter(field => field.infraestruturaSolicitanteId == unidade.infraestruturaSolicitanteId)
                            .reduce((sum, element) => {

                                sum = sum + this.unidade.cotaTipoId == this.enums.tipoCota.VALOR
                                    ? this.formatSumMoney(element.cota)
                                    : Number(element.cota)

                                return sum
                            },0)

                        cotasAtribuidas = cotasAtribuidas + cotaAtribuida

                        if (Number(cotasAtribuidas) === 0) {

                            Object.keys(unidadeSolicitante).forEach(solicitante => {

                                if (solicitante == "exames") {

                                    unidadeSolicitante[solicitante].map(exames => {

                                        cotaAtribuida = exames.unidadeSolicitante
                                            .filter(field => field.infraestruturaSolicitanteId == unidade.infraestruturaSolicitanteId)
                                            .reduce((sum, element) => {

                                                sum = sum + this.unidade.cotaTipoId == this.enums.tipoCota.VALOR
                                                    ? this.formatSumMoney(element.cota)
                                                    : Number(element.cota)

                                                return sum
                                            },0)

                                        cotasAtribuidas = cotasAtribuidas + cotaAtribuida
                                    })
                                }
                            })
                        }
                    })
                )
            }

            return this.unidade.cotaTipoId == this.enums.tipoCota.VALOR
                ? this.formatMoney(cotasAtribuidas, 2)
                : this.formatMoney(cotasAtribuidas, 0)
        },
        getSaldo(item) {

            if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let transferencia = this.formatMoney(item.transferencia, 2)
                let transferenciaRecebida = this.formatMoney(item.transferenciaRecebida, 2)
                let valorUtilizado = this.formatMoney(item.valorUtilizado, 2)
                valorUtilizado = this.formatSumMoney(valorUtilizado) / 100

                const saldo = ((this.formatSumMoney(cota) - valorUtilizado) - this.formatSumMoney(transferencia))
                    + this.formatSumMoney(transferenciaRecebida)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                const saldo =  (((item.cota) - item.quantidadeUtilizada) - Number(item.transferencia))
                    + Number(item.transferenciaRecebida)

                return this.formatMoney(saldo, 0)
            }
        },
        handleTranferencia(item, cotaUnidadeSolicitante) {

            const cota = this.data.model.cotasTransferencia.find((obj =>
                obj.origemInfraestruturaId == item.infraestruturaSolicitanteId
                && obj.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE
            ));

            let transferencia = 0
            let transferenciaRecebida = 0

            if (cota) {

                let cotaTransferencia = cota.destino.filter(i => { return i.origemCotaTipoId == this.unidade.cotaTipoId
                    && moment(
                        moment(this.unidade.periodo.start).format('YYYY-MM-DD')
                    )
                    .isBetween(
                        i.origemInicio.split("/").reverse().join("-"),
                        i.origemFim.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )

                    || i.origemCotaTipoId == this.unidade.cotaTipoId
                        && moment(
                            moment(this.unidade.periodo.end).format('YYYY-MM-DD')
                        )
                        .isBetween(
                            i.origemInicio.split("/").reverse().join("-"),
                            i.origemFim.split("/").reverse().join("-"),
                            null,
                            '[]'
                        )
                })

                let valorUnidade = cotaTransferencia
                    .filter(field => field.origemCotaTipoId == this.enums.tipoCota.VALOR)
                    .reduce((sum, element) => sum + this.formatSumMoney(element.destinoCotaValor), 0);

                let quantidadeUnidade =  cotaTransferencia
                    .filter(field => field.origemCotaTipoId == this.enums.tipoCota.QUANTIDADE)
                    .reduce((sum, element) => {

                        if (element.destinoCotaQuantidade) {
                            sum = sum + Number(element.destinoCotaQuantidade);
                        }

                        return sum;
                    },0)

                cotaTransferencia.map(exame => {

                    let cotaExameQuantidade = exame.exames.reduce((sum, element) => {

                        if (element.transferido && element.cotaQuantidadeTransferido) {
                            sum = sum + Number(element.transferido);
                        }

                        return sum;
                    },0)

                    quantidadeUnidade = quantidadeUnidade + cotaExameQuantidade

                    let cotaExameValor = exame.exames.filter(field => field.cotaValorTransferido > '0,00')
                        .reduce((sum, element) => sum + this.formatSumMoney(element.transferido), 0);

                    valorUnidade = this.formatMoney(valorUnidade, 2)
                    cotaExameValor = this.formatMoney(cotaExameValor, 2)

                    valorUnidade = this.formatSumMoney(valorUnidade) + this.formatSumMoney(cotaExameValor)
                    valorUnidade = this.formatMoney(valorUnidade, 2)
                })

                transferencia = this.unidade.cotaTipoId == this.enums.tipoCota.VALOR
                    ? valorUnidade
                    : quantidadeUnidade
            }

            let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                field.unidadeTipoId == this.enums.tipoUnidade.UNIDADE_SOLICITANTE)

            if (transferenciaLaboratorio.length > 0) {

                transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                Object.keys(transferenciaLaboratorio).forEach(a => {

                    let recebidos = transferenciaLaboratorio[a]
                        .filter(i => i.destinoInfraestruturaId == item.infraestruturaSolicitanteId
                            && i.origemCotaTipoId == this.unidade.cotaTipoId
                            && moment(
                                moment(this.unidade.periodo.start).format('YYYY-MM-DD')
                            )
                            .isBetween(
                                i.destinoInicio.split("/").reverse().join("-"),
                                i.destinoFim.split("/").reverse().join("-"),
                                null,
                                '[]'
                            )

                            || i.destinoInfraestruturaId == item.infraestruturaSolicitanteId
                                && i.origemCotaTipoId == this.unidade.cotaTipoId
                                && moment(
                                    moment(this.unidade.periodo.end).format('YYYY-MM-DD')
                                )
                                .isBetween(
                                    i.destinoInicio.split("/").reverse().join("-"),
                                    i.destinoFim.split("/").reverse().join("-"),
                                    null,
                                    '[]'
                                )
                        )

                    recebidos.forEach(v => {

                        if (this.unidade.cotaTipoId == this.enums.tipoCota.VALOR) {

                            transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)
                            transferenciaRecebida = this.formatSumMoney(transferenciaRecebida) +
                                this.formatSumMoney(this.getCotaExame(v))
                            transferenciaRecebida = this.formatMoney(transferenciaRecebida, 2)
                        } else {

                            transferenciaRecebida = transferenciaRecebida + this.getCotaExame(v)
                        }
                    });
                })
            }

            cotaUnidadeSolicitante.transferencia = transferencia
            cotaUnidadeSolicitante.transferenciaRecebida = transferenciaRecebida

            return cotaUnidadeSolicitante
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    let destinoCotaValor = this.formatMoney(item.destinoCotaValor, 2)
                    let cotaTotal = this.formatSumMoney(destinoCotaValor) + this.formatSumMoney(cotaExame)

                    return this.formatMoney(cotaTotal, 2)

                } else {

                    return item.destinoCotaValor
                }

            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return Number(item.destinoCotaQuantidade) + cotaExame
            }
        },
        handleExame(item, exame, exames) {

            let cota = this.data.model.cotasExamePeriodo.find(unidade =>
                unidade.unidadeId == this.unidadeId
                && unidade.infraestruturaId == this.infraestruturaId
                && unidade.cotaTipoId == item.cotaTipoId
                && moment(
                    moment(item.periodo.start).format('YYYY-MM-DD')
                ).isBetween(
                    unidade.periodo.start.split("/").reverse().join("-"),
                    unidade.periodo.end.split("/").reverse().join("-"),
                    null,
                    '[]'
                )
                && moment(
                    moment(item.periodo.end).format('YYYY-MM-DD')
                ).isBetween(
                    unidade.periodo.start.split("/").reverse().join("-"),
                    unidade.periodo.end.split("/").reverse().join("-"),
                    null,
                    '[]'
                )
            )

            if (!cota) {
                this.examesSemSaldo.push(exame)
                return false
            }

            if (exames.length > 0) {

                if (!exames.find(e => e.exameId == exame.exameId)) {
                    this.examesSemSaldo.push(exame)
                    return false
                }

                if (!this.getTotalExame(item, exame, exames)) {
                    this.examesSemSaldo.push(exame)
                    return false
                }
            }

            return true
        },
        getTotalExame(item, exame, exames) {

            let dataInicioExame = null
            let dataFimExame = null
            let liberado = true

            exames.filter(e => e.exameId == exame.exameId).map(itemPeriodo => {

                let limiteCota = false
                let examePeriodoId = null

                if (!dataInicioExame) {

                    dataInicioExame = itemPeriodo.periodo.start.split("/").reverse().join("-")
                } else {

                    if (moment(itemPeriodo.periodo.start.split("/").reverse().join("-")).isBefore(dataInicioExame)) {

                        dataInicioExame = itemPeriodo.periodo.start.split("/").reverse().join("-")
                    }
                }

                if (!dataFimExame) {

                    dataFimExame = itemPeriodo.periodo.end.split("/").reverse().join("-")
                } else {

                    if (moment(itemPeriodo.periodo.end.split("/").reverse().join("-")).isAfter(dataFimExame)) {

                        dataFimExame = itemPeriodo.periodo.end.split("/").reverse().join("-")
                    }
                }

                let cota = item.cotaTipoId == this.enums.tipoCota.QUANTIDADE
                    ?  Number(itemPeriodo.cota) : this.formatSumMoney(itemPeriodo.cota)

                if (item.cotaTipoId == this.enums.tipoCota.VALOR) {

                    if (cota) {

                        if (this.formatSumMoney(exame.cotaValor) <= cota) {

                            limiteCota = true
                            examePeriodoId = itemPeriodo.id
                        }
                    }
                } else {

                    if (cota) {

                        if (exame.cotaQuantidade <= cota) {

                            limiteCota = true
                            examePeriodoId = itemPeriodo.id
                        }
                    }
                }

                if (limiteCota) {

                    liberado = this.getExameCotaAtribuida(exame, examePeriodoId, dataInicioExame, dataFimExame, cota, item.cotaTipoId)
                } else {

                    liberado = false
                }
            })

            return liberado
        },
        getExameCotaAtribuida(item, examePeriodo, dataInicioExame, dataFimExame, cota, cotaTipoId) {

            let cotasAtribuidas = 0
            let atribuiNovaCota = 0

            this.data.model.cotasLaboratorio.find((unidade) => unidade.unidadeId == this.unidadeId
                && unidade.infraestruturaId == this.infraestruturaId).cotaLaboratorio.filter(field => moment(

                    field.periodo.start.split("/").reverse().join("-")
                )
                .isBetween(
                    dataInicioExame,
                    dataFimExame,
                    null,
                    '[]'
                )
                && moment(
                    field.periodo.end.split("/").reverse().join("-")
                )
                .isBetween(
                    dataInicioExame,
                    dataFimExame,
                    null,
                    '[]'
                )
            ).map(exame => {

                let cotaAtribuida = exame.exames.filter(field => field.exameId == item.exameId
                    && field.cotaExamePeriodoId == examePeriodo).reduce((sum, element) => {

                    if (exame.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if (element.cota) {

                            sum = sum + this.formatSumMoney(element.cota);
                        }
                    } else {

                        if (element.cota) {

                            sum = Number(sum) + Number(element.cota);
                        }
                    }

                    return sum
                },0)

                cotasAtribuidas = cotasAtribuidas + cotaAtribuida
            })

            atribuiNovaCota = cotaTipoId == this.enums.tipoCota.VALOR
                ? cotasAtribuidas + this.formatSumMoney(item.cotaValor)
                : cotasAtribuidas + Number(item.cotaQuantidade)

            return  cota >= atribuiNovaCota? true : false
        },
        hideAlter() {

            this.checkHandleAlter = false
            this.$emit('handleHideUnidadeSolicitante', false)
            this.resetForm()
        },
        save() {

            this.$emit('handleSave')
        }
    },
    props: {
        data: { type: Object, required: true },
        cotaLaboratorio: { type: Array, required: true },
        unidadeId: { type: Number, default: null },
        cotaAno: { type: String, default: null },
        infraestruturaId: { type: Number, default: null },
        laboratorioSolicitante: { type: Array, required: true },
        checkLaboratorio: { type: Boolean, required: true, default: false },
        unidadeDisabled: { type: Boolean, default: false },
        newIndex: { type: Number, default: null },
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {},
        unidade: {
            id: null,
            unidadeTipoId: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaTipoNome: null,
            periodo: {
                start: null,
                end: null
            },
            cotaValor: null,
            saldo: null,
            utilizada: null,
            valorUtilizado: '0',
            quantidadeUtilizada: '0',
            cotaQuantidade: '',
            observacao: '',
            exames: [],
            unidadeSolicitante: [],
            cotaAtribuida: '0',
            alterado: true,
            exameAlterado: true,
            unidadeAlterada: false,
        },
        checkHandleAlter: false,
        checkUnidadeSolicitante: true,
        nomeFantasiaUnidadeSolicitante: null,
        cotaAtribuida: null,
        utilizadas: 0,
        examesSemSaldo: [],
        unidadeSemSaldo: [],
        index: null,
        aguardandoConfirmacao: false,
        enums: {
            tipoCota,
            tipoUnidade,
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
     }),
}
</script>